import { all } from '../services/restApi'
import { batchObject, batchArray } from '../services/batch'
import { message } from 'antd'
import config from '../utils/config'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'seller',
	state : {
		sellers: [],
		skip: 0,
		limit: limit,
		total_items: 0
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/all_users/list-sellers') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*firstLoad({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				let query = {type: 'vendedor'};
				if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
					query.companies = {$all: [{__type: 'Pointer', className: 'TourCompany', objectId: JSON.parse(localStorage.getItem('currentHotel')).objectId}]}

				const resp = yield call(all, '_User', {
					where: query,
					include: 'companies',
					skip: 0, limit: limit, count: 1, order: '-createdAt'
				})
				const sellers = resp.results;

				yield put({ type: 'queryFirst', payload: {
					sellers: sellers, 
					skip: limit,
					total_items: resp.count,
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, 
					include: 'companies'
				};

				const resp = yield call(all, '_User', data)
				const sellers = resp.results;

				yield put({ type: 'querySuccess', payload: {
					sellers: sellers,
					skip: data.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {
				// Model
				let data = {...payload};
		        data._method = "PUT";

		        data.companies = [];
		        payload.companies.map(item => {
		        	return data.companies.push({ __type: 'Pointer', className: 'TourCompany', objectId: item.objectId });
		        });

				data = _.omit(data, ['createdAt', 'updatedAt']);			

				yield call(batchObject, '_User', data.objectId, data._method, data)
				yield put({ type: 'updateSuccess', payload: {...data, companies: payload.companies, objectId: payload.objectId} })
				message.success('Se ha actualizado el vendedor exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				let data = {};
		        data.requests = [{method: "DELETE", path: "/"+ config.slug +"/classes/_User/" + payload.objectId}];

				yield call(batchArray, data);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				sellers: state.sellers.concat(action.payload.sellers),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.sellers, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)
			
			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {
			return {
				...state,
    			sellers: _.without(state.sellers, action.payload)
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/seller.js